import { Types as CoreTypes } from '@cornerstonejs/core';
import {
  AnnotationDisplayTool,
  Types as ToolsTypes,
  annotation as annotationTools,
  drawing,
} from '@cornerstonejs/tools';

type IEnabledElement = CoreTypes.IEnabledElement;
type SVGDrawingHelper = ToolsTypes.SVGDrawingHelper;
type StyleSpecifier = ToolsTypes.AnnotationStyle.StyleSpecifier;
type Annotation = ToolsTypes.Annotation;

/**
 * Draws the contour of a contour Detection, such as a Pre-annotation (see
 * CONTEXT.md), on its own slice. Display only: the annotator paints over it
 * with the Brush and can never select, move or edit it, so the tool answers
 * no pointer interaction.
 */
class GleamerPredictionContourTool extends AnnotationDisplayTool {
  static toolName = 'GleamerPredictionContourTool';

  /** See GleamerPredictionRectangleTool.cancel: nothing to cancel, but it must answer. */
  cancel(): undefined {
    return undefined;
  }

  isPointNearTool(): boolean {
    return false;
  }

  getHandleNearImagePoint(): undefined {
    return undefined;
  }

  renderAnnotation(
    enabledElement: IEnabledElement,
    svgDrawingHelper: SVGDrawingHelper
  ): boolean {
    const { viewport } = enabledElement;
    const { element } = viewport;
    const annotationManager = annotationTools.state.getAnnotationManager();

    let annotations = annotationManager.getAnnotations(
      annotationManager.getGroupKey(element),
      this.getToolName()
    );
    if (!annotations?.length) {
      return false;
    }
    annotations = this.filterInteractableAnnotationsForElement(
      element,
      annotations
    );
    if (!annotations?.length || !viewport.getRenderingEngine()) {
      return false;
    }

    const styleSpecifier: StyleSpecifier = {
      toolGroupId: this.toolGroupId,
      toolName: this.getToolName(),
      viewportId: viewport.id,
    };

    for (const annotation of annotations as Annotation[]) {
      const { annotationUID, data } = annotation;
      if (!annotationTools.visibility.isAnnotationVisible(annotationUID)) {
        continue;
      }
      styleSpecifier.annotationUID = annotationUID;
      const canvasPoints = data.handles.points.map((point) =>
        viewport.worldToCanvas(point)
      );

      drawing.drawPolyline(
        svgDrawingHelper,
        annotationUID,
        'contour',
        canvasPoints,
        {
          color: this.getStyle('color', styleSpecifier, annotation),
          lineWidth: this.getStyle('lineWidth', styleSpecifier, annotation),
          lineDash: this.getStyle('lineDash', styleSpecifier, annotation),
          // The AI team ships open rings: the last vertex joins the first.
          closePath: true,
        }
      );
    }

    return true;
  }
}

export default GleamerPredictionContourTool;
